<template>
  <v-tooltip top transition="fade-transition" v-if="single">
    <template v-slot:activator="{ on }">
      <v-btn icon small :to="single.method(item)" v-on="on">
        <v-icon :small="small">{{ single.icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ single.label }}</span>
  </v-tooltip>
  <v-menu bottom left min-width="150" v-else>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" icon small>
        <v-icon :small="small" v-text="$vuetify.icons.values.options" />
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="(opt, idx) in available" :key="`option-${idx}-${item.refid}`" :to="opt.method(item)">
        <v-list-item-title>{{ opt.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import ConfirmDeleteDialog from './ConfirmDeleteDialog'
import { create } from 'vue-modal-dialogs'
const confirmDeleteAction = create(ConfirmDeleteDialog)

export default {
  name: 'OptionMenu',
  props: {
    item: Object,
    showItem: Function,
    viewItem: Function,
    editItem: Function,
    deleteItem: Function,
    noConfirm: { type: Boolean, default: false },
    small: { type: Boolean, default: true }
  },
  computed: {
    available() {
      return [
        { method: this.showItem, label: this.$t('labels.show'), icon: this.$vuetify.icons.values.view },
        { method: this.viewItem, label: this.$t('labels.view'), icon: this.$vuetify.icons.values.view },
        { method: this.editItem, label: this.$t('labels.edit'), icon: this.$vuetify.icons.values.edit },
        { method: this.deleteItem, label: this.$t('labels.delete'), icon: this.$vuetify.icons.values.trash }
      ]
        .filter((x) => !!x.method)
        .map((x) => ({ ...x, method: x.label === this.$t('labels.delete') ? this.onDelete : x.method }))
    },
    single() {
      return this.available.length === 1 ? this.available[0] : false
    }
  },
  methods: {
    onDelete(item) {
      if (this.noConfirm) {
        return this.deleteItem(item)
      }

      confirmDeleteAction().then((res) => {
        if (res) {
          return this.deleteItem(item)
        }
      })
    }
  }
}
</script>
